var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mt-5"},[_c('div',{staticClass:"col-md-6 mx-auto"},[_c('h1',{staticClass:"text-center"},[_vm._v("404")]),_vm._v(" "),_c('h1',[_vm._v("\n            This is not the webpage you are looking for!\n        ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b6b4d2a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/additions/PageNotFound.vue
// module id = 754
// module chunks = 0